import './index.scss';
import { calendar } from '../../calendar';
import React, { Component } from 'react';
import moment from 'moment';
import { DatePicker, Flex, Icon } from 'antd-mobile';

const DatePickerChildren = ({ onClick, extra }) => (
  <div onClick={onClick} className="date">
    <i>{moment(extra).format('YYYY-MM')}</i>
  </div>
);

export default class Calendar extends Component {
  state = {
    current: new Date(),
    selected: new Date(),
  };

  getMonthCount = () => {
    const { current } = this.state;
    const count = moment(current).daysInMonth();
    const prevPlaceholder = Array.from(
      new Array((moment(current).startOf('month').weekday() || 7) - 1),
      () => '',
    );
    return prevPlaceholder.concat(Array.from(new Array(count), (item, value) => value + 1));
  };

  prevMonth = async () => {
    const { onMonthChange } = this.props;
    const { current } = this.state;
    const newDate = moment(current).add(-1, 'months');
    if (newDate.year() < 2000) {
      return;
    }
    await this.setState({ current: newDate.toDate() });
    if (onMonthChange) onMonthChange(newDate.format('YYYY-MM'));
  };

  nextMonth = async () => {
    const { onMonthChange } = this.props;
    const { current } = this.state;
    const newDate = moment(current).add(1, 'months');
    if (newDate.year() > 2030) {
      return;
    }
    await this.setState({ current: newDate.toDate() });
    if (onMonthChange) onMonthChange(newDate.format('YYYY-MM'));
  };

  monthChange = async (value) => {
    const { onMonthChange } = this.props;
    this.setState({ current: value });
    if (onMonthChange) onMonthChange(moment(value).format('YYYY-MM'));
  };

  dateChange = async (value) => {
    const { onChange } = this.props;
    const { current } = this.state;
    const newDate = moment(current).date(value);
    await this.setState({ selected: newDate.toDate() });
    if (onChange) onChange(newDate.format('YYYY-MM-DD'), newDate);
  };

  isWeekend = (date) => {
    const weekday = date.day();
    if (weekday === 0 || weekday === 6) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    const dates = this.getMonthCount();
    const { current, selected } = this.state;
    let { years, months } = moment(current).toObject();
    const { dotList } = this.props;

    return (
      <div className="calendar">
        <div className="calendar-control-bar">
          <Flex>
            <Flex.Item>
              <button className="prev" onClick={this.prevMonth}>
                <Icon type="left" />
              </button>
            </Flex.Item>
            <Flex.Item>
              <div className="date">
                <DatePicker
                  mode="month"
                  format="YYYY-MM"
                  value={current}
                  onChange={this.monthChange}
                  extra={current}
                  minDate={new Date(2000, 0)}
                  maxDate={new Date(2030, 11)}
                >
                  <DatePickerChildren />
                </DatePicker>
              </div>
            </Flex.Item>
            <Flex.Item>
              <button className="next" onClick={this.nextMonth}>
                <Icon type="right" />
              </button>
            </Flex.Item>
          </Flex>
        </div>
        <div className="calendar-container">
          <div className="calendar-container-inner">
            {dates.map((item, index) => {
              let dateItem;
              if (item) {
                const dateTime = moment(current);
                dateTime.date(item);
                dateItem = (
                  <div
                    className={`date-item${
                      moment(selected).format('YYYY-MM-DD') === dateTime.format('YYYY-MM-DD')
                        ? ' selected'
                        : ''
                    }${this.isWeekend(dateTime) ? ' weekend' : ''}`}
                    key={`date-${dateTime.format('YYYY-MM-DD')}`}
                    onClick={() => {
                      this.dateChange(item);
                    }}
                  >
                    <div className="inner">
                      {dotList.indexOf(dateTime.format('YYYY-MM-DD')) > -1 ? (
                        <em className="dot" />
                      ) : null}
                      <p className="date">{item}</p>
                      <p className="lunar-date">
                        {calendar.solar2lunar(years, months, item).IDayCn}
                      </p>
                    </div>
                  </div>
                );
              } else {
                dateItem = <div className="date-item" key={`date-prev-${index}`} />;
              }
              return dateItem;
            })}
          </div>
        </div>
      </div>
    );
  }
}
